import { render, staticRenderFns } from "./BotaoRastreabilidadeGestaoBungeEmpresa.vue?vue&type=template&id=56936151&lang=pug"
import script from "./BotaoRastreabilidadeGestaoBungeEmpresa.vue?vue&type=script&lang=js"
export * from "./BotaoRastreabilidadeGestaoBungeEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports